// extracted by mini-css-extract-plugin
module.exports =  {"note":"style-module_note__uQJU2coAz4HhWY8KOGaA","checkboxNote":"style-module_checkboxNote__TG0E5bTWDgS75ZrcWr_m","header":"style-module_header__HpnhyyK9CGtoQfSm_MY8"};